import type { HelpFile } from '../../types/help'
import { AccessSnapshotViewTestIds } from '../../../testids/AccessSnapshotViewTestIds'

export const accessSnapshotViewHelp: HelpFile = {
  docPage: '/docs/effective-access/snapshot',
  texts: {
    [AccessSnapshotViewTestIds.colEntitlement]: 'Access profile granted to this identity.',
    [AccessSnapshotViewTestIds.colOperation]: 'Operation the identity may perform on the resource — for example read, write, or admin.',
    [AccessSnapshotViewTestIds.colResource]: 'Resource on which this access applies.',
    [AccessSnapshotViewTestIds.colSource]: 'How this access was granted — directly, via a role, function group, or Auto-Assign Rule.',
    [AccessSnapshotViewTestIds.colValidUntil]: 'Expiry date of this access grant — empty means no expiry.',
  },
}
